import { useUserStore } from '../../../store/models';

// Access is granted only to internal/test email domains.
const ENV_ALLOWED_EMAIL_SUFFIXES = ['mailosaur.net', 'instantbox.live'];

// Exact-match allowlist (not suffix-based).
const ENV_ALLOWED_EMAILS = ['sobhan@e-diary.com', 'sabin@e-diary.com', 'damon@e-diary.com'];

function isEmailAllowed (email, env) {
    if (env === 'dev') {
        return true
    }

    if (env === 'stage') {
        return ENV_ALLOWED_EMAILS.includes(email) || ENV_ALLOWED_EMAIL_SUFFIXES.some((suffix) => email.endsWith(suffix));
    }

    if (env === 'prod') {
        return ENV_ALLOWED_EMAILS.includes(email);
    }

    return false;
}

function useConnectIntegrationByDev () {
    const userStore = useUserStore();
    // Read the observed token so MobX resubscribes when a superadmin switches publisher.
    void userStore.observed.publisher;
    const publisherEmail = userStore.publisher?.email || '';
    const env = import.meta.env.VITE_ENV_VAR || 'dev';

    const devAccess = isEmailAllowed(publisherEmail, env);

    return {
        devAccess,
    };
}

export default useConnectIntegrationByDev;
